import React from 'react';
import styled from 'styled-components';
import { DEVICES_STORAGE_KEY } from 'packages/smart-home-support/constants';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import Button from 'packages/smart-home-support/components/Button';
import CalculatorSelection from '../calculator/selection/components/CalculatorSelection';
import { DeviceQuantities, Devices } from '../calculator/models';
import defaultDevices from '../../resources/calculator/devices.json';
import localStorage, { remove } from 'local-storage';

const isNothingSelected = (deviceQuantities: DeviceQuantities) => {
  return (
    Object.keys(deviceQuantities).length === 0 ||
    Object.keys(deviceQuantities).filter((f) => deviceQuantities[f] > 0).length === 0
  );
};

const ButtonFooterContainer = styled.div`
  background-color: black;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 2%;
  height: 72px;

  & :nth-child(2) {
    float: right;
    margin-right: 4%;
  }

  > * {
    top: 12px;
    width: 45%;
  }

  @media ${BREAK_POINTS.desktop} {
    display: none;
  }
`;

const BorderedButton = styled(Button)`
  border: 1px solid white;
`;

const ButtonContainer = styled.div`
  display: none;

  @media ${BREAK_POINTS.desktop} {
    display: flex;
    margin-top: 56px;

    > * {
      width: 216px;
      margin-left: 8px;
      margin-right: 8px;
    }
  }
`;

const CalculatorContainer = styled.div`
  margin-bottom: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Descriptor = styled.div`
  margin: 25px;
`;

export interface AddDevicesProps {
  devices: Devices;
}

const AddDevices: React.SFC<AddDevicesProps> = (props) => {
  let devices = props.devices;

  if (!devices || typeof devices !== 'object' || Object.keys(devices).length === 0) {
    devices = defaultDevices;
  }

  const [deviceQuantities, setDeviceQuantities] = React.useState<DeviceQuantities>({});

  return (
    <>
      <CalculatorContainer>
        <Descriptor>Keep track of your devices by adding them to your account.</Descriptor>
        <CalculatorSelection
          devices={devices}
          deviceQuantities={deviceQuantities}
          onChangeDeviceQuantities={setDeviceQuantities}
          allowTwoColumns={true}
        />
        <ButtonContainer>
          <Button
            inverted={true}
            onClick={() => {
              remove(DEVICES_STORAGE_KEY);
            }}
            to="/user/login"
          >
            Not now
          </Button>
          <Button
            onClick={() => {
              localStorage(DEVICES_STORAGE_KEY, deviceQuantities);
            }}
            to="/user/login"
            disabled={isNothingSelected(deviceQuantities)}
          >
            Save
          </Button>
        </ButtonContainer>
      </CalculatorContainer>
      <ButtonFooterContainer>
        <BorderedButton
          onClick={() => {
            remove(DEVICES_STORAGE_KEY);
          }}
          to="/user/login"
        >
          Not now
        </BorderedButton>
        <Button
          inverted={true}
          onClick={() => {
            localStorage(DEVICES_STORAGE_KEY, deviceQuantities);
          }}
          to="/user/login"
          disabled={isNothingSelected(deviceQuantities)}
        >
          Save
        </Button>
      </ButtonFooterContainer>
    </>
  );
};

export default AddDevices;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/add-devices/index.tsx